    export class Attachment {
      Id?: number;
      RecordId?: number;
      EntityTypeId: number;
      ParentId: number;
      UniqueId: string;
      FileName: string;
      Caption: string;
      ContentType: string;
      syncStatus: number;
      dataUrl?: string;
      UserId: number;
      IsDeleted: boolean;

      constructor(obj?: Partial<Attachment>) {
        if (obj) {
          Object.assign(this, obj);
        } else {
          throw Error('Object cannot be null');
        }
      }

      isSoftDeleted(): boolean {
        return this.IsDeleted;
      }
    }
